import React, { useState, useEffect } from "react";
import api from "../../api";

export default function BroadcastList({ onCreate, broadcasts = [], page=1, pageSize=20, total=0, onChangePage, onChangePageSize }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState({ loading: false, error: "", items: [], count: 0 });
  const [contentOpen, setContentOpen] = useState(false);
  const [contentTitle, setContentTitle] = useState("");
  const [contentBody, setContentBody] = useState("");
  const [contentMailId, setContentMailId] = useState(null);

  function typeLabel(rec) {
    if (!rec || !rec.type) return "Unbekannt";
    if (rec.type === 'all') return 'Alle Benutzer';
    if (rec.type === 'role') return `Rolle: ${rec.value}`;
    if (rec.type === 'user') return 'Einzelner Nutzer';
    if (rec.type === 'newsletter') return 'Newsletter-Abonnenten';
    return rec.type;
  }

  async function openRecipients(b) {
    const label = typeLabel(b.recipientParsed) || 'Empfänger';
    setModalTitle(`${label}`);
    setModalOpen(true);
    setModalData({ loading: true, error: "", items: [], count: 0 });
    try {
      const res = await api.get(`/rundmail/${b.id}/recipients`);
      const items = Array.isArray(res.data?.recipients) ? res.data.recipients : [];
      setModalData({ loading: false, error: "", items, count: res.data?.count || items.length });
    } catch (e) {
      setModalData({ loading: false, error: e?.response?.data?.error || 'Fehler beim Laden der Empfängerliste.', items: [], count: 0 });
    }
  }

  function openContent(b) {
    setContentTitle(b.subject || 'Nachricht');
    const plain = (b.body && String(b.body)) || '';
    const html = (b.bodyHtml && String(b.bodyHtml)) || '';
    const fallbackText = html ? html.replace(/<[^>]+>/g, '').replace(/\s+$/,'') : '';
    setContentBody(plain || fallbackText);
    setContentMailId(b.id);
    setContentOpen(true);
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <h3 style={{ margin: 0 }}>Rundmail-Übersicht</h3>
        <button onClick={onCreate} style={{ padding: "8px 20px", borderRadius: 8, background: "#1976d2", color: "#fff", border: "none", fontWeight: 500, cursor: "pointer" }}>
          Neue Rundmail
        </button>
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
        <div style={{ color:'#bbb', fontSize:13 }}>Gesamt: {total}</div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <label style={{ color:'#ccc', fontSize:13 }}>Pro Seite:
            <select value={pageSize} onChange={e => onChangePageSize && onChangePageSize(parseInt(e.target.value,10) || 20)} style={{ marginLeft:6, background:'#181818', color:'#fff', border:'1px solid #333', borderRadius:6, padding:'4px 8px' }}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </label>
          <button onClick={() => onChangePage && onChangePage(Math.max(1, page-1))} disabled={page<=1} style={{ padding:'6px 10px', borderRadius:6, border:'1px solid #333', background:'#2a2a2a', color:'#fff', cursor: page<=1 ? 'not-allowed' : 'pointer' }}>Zurück</button>
          <div style={{ color:'#ccc', fontSize:13 }}>Seite {page} / {Math.max(1, Math.ceil(total / pageSize))}</div>
          <button onClick={() => onChangePage && onChangePage(page + 1)} disabled={page >= Math.ceil(total / pageSize)} style={{ padding:'6px 10px', borderRadius:6, border:'1px solid #333', background:'#2a2a2a', color:'#fff', cursor: (page >= Math.ceil(total / pageSize)) ? 'not-allowed' : 'pointer' }}>Weiter</button>
        </div>
      </div>
      <table style={{ width: "100%", background: "#222", borderRadius: 8, overflow: "hidden" }}>
        <thead>
          <tr style={{ background: "#333", color: "#fff" }}>
            <th style={{ padding: "10px 8px", textAlign: "left" }}>Betreff</th>
            <th style={{ padding: "10px 8px", textAlign: "left" }}>Empfänger</th>
            <th style={{ padding: "10px 8px", textAlign: "left" }}>Versand</th>
            <th style={{ padding: "10px 8px", textAlign: "left" }}>Gesendet am</th>
          </tr>
        </thead>
        <tbody>
          {broadcasts.length === 0 ? (
            <tr><td colSpan={4} style={{ padding: 16, textAlign: "center", color: "#888" }}>Keine Rundmails vorhanden.</td></tr>
          ) : (
            broadcasts.map(b => (
              <tr key={b.id} style={{ borderBottom: "1px solid #333" }}>
                <td style={{ padding: "10px 8px" }}>
                  <button
                    onClick={() => openContent(b)}
                    title="Nachrichteninhalt anzeigen"
                    style={{
                      background: 'transparent',
                      color: '#8ab4ff',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      fontSize: 'inherit',
                    }}
                  >
                    {b.subject}
                  </button>
                </td>
                <td style={{ padding: "10px 8px" }}>
                  <button
                    onClick={() => openRecipients(b)}
                    title="Empfänger anzeigen"
                    style={{
                      background: '#2b3a55',
                      color: '#fff',
                      border: '1px solid #3a4a6a',
                      borderRadius: 14,
                      padding: '4px 10px',
                      fontSize: 12,
                      cursor: 'pointer'
                    }}
                  >
                    {typeLabel(b.recipientParsed)}{typeof b.recipientsCount === 'number' ? ` (${b.recipientsCount})` : ''}
                  </button>
                </td>
                <td style={{ padding: "10px 8px" }}>{b.delivery}</td>
                <td style={{ padding: "10px 8px" }}>{(b.sentAt || b.createdAt) ? new Date(b.sentAt || b.createdAt).toLocaleString() : "—"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {modalOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ width:'min(800px, 92vw)', maxHeight:'80vh', overflow:'auto', background:'#1f1f1f', border:'1px solid #333', borderRadius:8, boxShadow:'0 10px 30px rgba(0,0,0,0.4)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', borderBottom:'1px solid #2a2a2a' }}>
              <div style={{ fontWeight:600 }}>{modalTitle}</div>
              <button onClick={() => setModalOpen(false)} style={{ background:'#333', color:'#fff', border:'none', borderRadius:6, padding:'6px 10px', cursor:'pointer' }}>Schließen</button>
            </div>
            <div style={{ padding:16 }}>
              {modalData.loading && <div style={{ color:'#aaa' }}>Lade Empfängerliste…</div>}
              {modalData.error && <div style={{ color:'#e53935' }}>{modalData.error}</div>}
              {!modalData.loading && !modalData.error && (
                <div>
                  <div style={{ marginBottom:10, color:'#ccc' }}>Gesamt: <strong>{modalData.count}</strong></div>
                  {modalData.items.length === 0 ? (
                    <div style={{ color:'#888' }}>Keine Empfänger gefunden.</div>
                  ) : (
                    <table style={{ width:'100%', borderCollapse:'collapse' }}>
                      <thead>
                        <tr style={{ background:'#2a2a2a' }}>
                          <th style={{ textAlign:'left', padding:'8px 6px' }}>Name</th>
                          <th style={{ textAlign:'left', padding:'8px 6px' }}>E-Mail</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modalData.items.map((r, idx) => (
                          <tr key={(r.id ?? r.email ?? idx) + ':' + idx} style={{ borderTop:'1px solid #2a2a2a' }}>
                            <td style={{ padding:'8px 6px', color:'#ddd' }}>{r.displayName || r.username || '—'}</td>
                            <td style={{ padding:'8px 6px', color:'#bbb' }}>{r.email || '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {contentOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ width:'min(800px, 92vw)', maxHeight:'80vh', overflow:'auto', background:'#1f1f1f', border:'1px solid #333', borderRadius:8, boxShadow:'0 10px 30px rgba(0,0,0,0.4)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', borderBottom:'1px solid #2a2a2a' }}>
              <div style={{ fontWeight:600 }}>{contentTitle}</div>
              <button onClick={() => setContentOpen(false)} style={{ background:'#333', color:'#fff', border:'none', borderRadius:6, padding:'6px 10px', cursor:'pointer' }}>Schließen</button>
            </div>
            <ContentPreview contentTitle={contentTitle} rawText={contentBody} mailIdForHtml={contentMailId} />
          </div>
        </div>
      )}
    </div>
  );
}

function ContentPreview({ contentTitle, rawText, mailIdForHtml }) {
  const [tab, setTab] = useState('text');
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { setTab('text'); setHtml(''); setError(''); }, [contentTitle, rawText, mailIdForHtml]);

  useEffect(() => {
    if (tab !== 'html') return;
    if (!mailIdForHtml) { setError('Keine HTML-Vorschau verfügbar.'); return; }
    setLoading(true); setError('');
    api.get(`/rundmail/${mailIdForHtml}/previewHtml`)
      .then(res => setHtml(res.data?.html || ''))
      .catch(() => setError('Fehler beim Laden der HTML-Vorschau.'))
      .finally(() => setLoading(false));
  }, [tab, mailIdForHtml]);

  return (
    <div style={{ padding:16 }}>
      <div style={{ display:'flex', gap:8, marginBottom:12 }}>
        <button onClick={() => setTab('text')} style={{ padding:'6px 10px', borderRadius:6, border:'1px solid #333', background: tab==='text' ? '#2f4c7a' : '#2a2a2a', color:'#fff' }}>Text</button>
        <button onClick={() => setTab('html')} style={{ padding:'6px 10px', borderRadius:6, border:'1px solid #333', background: tab==='html' ? '#2f4c7a' : '#2a2a2a', color:'#fff' }}>HTML</button>
      </div>
      {tab === 'text' && (
        <div style={{ whiteSpace:'pre-wrap', lineHeight:1.5, color:'#ddd' }}>{rawText}</div>
      )}
      {tab === 'html' && (
        <div>
          {loading && <div style={{ color:'#aaa' }}>Lade HTML…</div>}
          {error && <div style={{ color:'#e53935' }}>{error}</div>}
          {!loading && !error && (
            <iframe title="html-preview" style={{ width:'100%', height:'60vh', background:'#fff', border:'1px solid #333', borderRadius:6 }} srcDoc={html}></iframe>
          )}
        </div>
      )}
    </div>
  );
}
